module.exports = __webpack_public_path__ + "static/media/homesetup-media.fd215f9d.jpeg";